import React from 'react';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
const Divider = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: treeStyles['sib-tree-view__divider']
  });
};
export default Divider;